import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';
import {} from 'react-icons/';
import { AiOutlineFileText } from 'react-icons/ai';
import { BsBuilding, BsPeopleFill, BsPerson } from 'react-icons/bs';
import { FiExternalLink } from 'react-icons/fi';
import { useParams } from 'react-router-dom';

import { Card } from '../../components/atoms/Card';

import { useLocalStorage } from '../../hooks/useLocalStorage';

import { ManagementService } from '../../services/ManagementService';
import { GetCompanyInfoResponse, IShareholder } from '../../services/Interfaces/IManagemenntService';

import formatDate from '../../utils/formatData';
import { getJurisdictionLabel } from '../../utils/jurisdiction';
import { useApi } from '../../services/hooks/apiHook';
import { AxiosInstance } from 'axios';

const getDirectorsFromShareholders = (shareholders: IShareholder[]) => {
  return shareholders.filter((s) => s.is_director === 1);
};

const CompanyDetailsScreen: React.FunctionComponent = () => {
  const [companyInfo, setCompanyInfo] = useState<GetCompanyInfoResponse['data']>();

  const { slug } = useParams();
  const [token] = useLocalStorage('access-token', null);
  const { i18n } = useTranslation();
  const api: AxiosInstance = useApi();

  useEffect(() => {
    (async () => {
      const { data } = await ManagementService.getCompanyInfo(api, slug!, {
        headers: { 'Content-Language': i18n.language.toLowerCase(), Authorization: `Bearer ${token}` }
      });

      setCompanyInfo(data);
    })();
  }, []);

  const directors = companyInfo?.shareholders ? getDirectorsFromShareholders(companyInfo?.shareholders) : [];
  const changeOpen = () => undefined;
  return (
    <>
      <div className="flex w-full flex-row justify-between border-b-[2px] pb-3">
        <div className="flex flex-col">
          <h2 className="text-xl font-bold text-[#0C1FAA]">{t('labels.lblCompanyDetails')}</h2>
          <span className="font-light text-[#727272]">{t('labels.lblCompanyDetails')}</span>
        </div>
      </div>

      <div className="mt-2 flex flex-row items-center justify-end gap-4">
        <button className="flex h-12 flex-row items-center justify-center gap-3 rounded-lg border-2 border-solid border-[#0C1FAA] px-5 text-xs text-[#0C1FAA]">
          <BsBuilding />
          send document to the office
        </button>

        <button className="flex h-12 flex-row items-center justify-center gap-3 rounded-lg border-2 border-solid border-[#0C1FAA] px-5 text-xs text-[#0C1FAA]">
          <BsPerson />
          Message to register office
        </button>

        <button className="flex h-12 flex-row items-center justify-center gap-3 rounded-lg border-2 border-solid border-[#0C1FAA] px-5 text-xs text-[#0C1FAA]">
          <BsPerson />
          Message to approval
        </button>

        <button className="flex h-12 flex-row items-center justify-center gap-3 rounded-lg border-2 border-solid border-[#0C1FAA] px-5 text-xs text-[#0C1FAA]">
          <BsPeopleFill />
          Message to user
        </button>
      </div>

      <Card.Root className="mt-4">
        <Card.Header className="font-medium">
          <h3 className="text-lg font-medium">{t('labels.lblCompanyInfo')}</h3>
        </Card.Header>

        <Card.Content className="justify-between">
          <div>
            <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblRegistrationNo')}</h3>
            <span className="text-base text-[#727272]">{companyInfo?.registration_number}</span>
          </div>

          <div>
            <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblCompanyName')}</h3>
            <span className="text-base text-[#727272]">{companyInfo?.name}</span>
          </div>

          <div>
            <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblFinancialYear')}</h3>
            <span className="text-base text-[#727272]">{companyInfo?.financial_year}</span>
          </div>

          <div>
            <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblIncorporationDate')}</h3>
            <span className="text-base text-[#727272]">{companyInfo?.incorporation_date}</span>
          </div>

          <div>
            <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblCompanyStatus')}</h3>
            <span className="text-base text-[#727272]">{companyInfo?.status}</span>
          </div>

          <div>
            <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblJurisdictions')}</h3>
            <span className="text-base text-[#727272]">
              {getJurisdictionLabel(companyInfo?.jurisdiction) || t('labels.lblNoDataAvailable') || '---'}
            </span>
          </div>
        </Card.Content>
      </Card.Root>

      <div className="mt-4 flex flex-row gap-4">
        <Card.Root className="flex-1">
          <Card.Header className="font-medium">{t('labels.lblCompanyInfo')}</Card.Header>

          <Card.Content className="flex-col text-base text-[#727272]">
            <span>
              <b>{t('labels.lblAddress1')}:</b> Avenida Galeão
            </span>
            <span>
              <b>{t('labels.lblAddress2')}:</b> Avenida Galeão
            </span>
            <span>
              <b>{t('labels.lblPostalCode')}:</b> 66110-040
            </span>
            <span>
              <b>{t('labels.lblCity')}:</b> Pará
            </span>
            <span>
              <b>{t('labels.lblState')}:</b> Bélem
            </span>
            <span>
              <b>{t('labels.lblNeighborhood')}:</b> Maracangalha
            </span>
            <span>
              <b>label={t('labels.lblCountry')}:</b> Brazil
            </span>
          </Card.Content>
        </Card.Root>

        {/* <Card.Root className="flex-1">
          <Card.Header className="font-medium">{t('labels.lblEconomicSubstance')}</Card.Header>

          <Card.Content className="flex-col">
            <div>
              <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblPrincipalActivity')}</h3>
              <span className="text-base text-[#727272]">
                [4530703] Representantes comerciais e agentes do comércio de veículos automotores
              </span>
            </div>

            <div>
              <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblSecondaryActivity')}</h3>
              <span className="text-base text-[#727272]">
                [4530703] Representantes comerciais e agentes do comércio de veículos automotores
              </span>
            </div>
          </Card.Content>
        </Card.Root> */}
      </div>

      {directors.length ? (
        <Card.Root className="mt-4">
          <Card.Header className="font-medium">{t('others.othDirectors')}</Card.Header>
          <Card.Content className="flex-col gap-2">
            <h3 className="font-bold">Personal document</h3>

            <div className="flex flex-1 flex-row items-start gap-6">
              <img src="/svg/director-asset.png" className="aspect-square h-16" alt="" />

              <div className="flex flex-1 flex-row items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{directors[0].name}</h3>
                  <div>
                    <p className="text-base text-[#727272]">{directors[0].telefones[0]?.number}</p>
                    <p className="text-base text-[#727272]">{directors[0].email}</p>
                  </div>
                </div>

                <div className="flex-1">
                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">Date of becoming</h3>
                    <span className="text-base text-[#727272]">{directors[0].created_at}</span>
                  </div>

                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">Date of Birth</h3>
                    <span className="text-base text-[#727272]">{directors[0].date_of_birth}</span>
                  </div>
                </div>

                <div className="flex-1">
                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblGender')}</h3>
                    <span className="text-base text-[#727272]">{directors[0].gender}</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblNationality')}</h3>
                    <span className="text-base text-[#727272]">{directors[0].nationality}</span>
                  </div>
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblAddress1')}</h3>
                  <div className="flex flex-col text-base   text-[#727272]">
                    <span>
                      <b>{t('labels.lblPostalCode')}:</b> {directors[0].address[0]?.postal_code}
                    </span>
                    <span>
                      <b>STREET:</b> {directors[0].address[0]?.address}
                    </span>
                    <span>
                      <b>{t('labels.lblState')}:</b> {directors[0].address[0]?.state}
                    </span>
                    <span>
                      <b>{t('labels.lblCity')}:</b> {directors[0].address[0]?.city}
                    </span>
                    <span>
                      <b>{t('labels.lblNeighborhood')}:</b> {directors[0].address[0]?.neighborhood}
                    </span>
                    <span>
                      <b>label={t('labels.lblCountry')}:</b> {directors[0].address[0]?.country}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="mt-6 font-bold">About Passport</h3>

            <div className="flex flex-1 flex-row items-start justify-between">
              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblPassportNo')}*</h3>
                <p className="text-base text-[#727272]">{directors[0].passports[0]?.number}</p>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Expiry Date</h3>
                <p className="text-base text-[#727272]">{directors[0].passports[0]?.expiry_date}</p>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Passport Country</h3>
                <p className="text-base text-[#727272]">{directors[0].passports[0]?.issuing_country}</p>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Issuance date</h3>
                <p className="text-base text-[#727272]">{directors[0].passports[0]?.issuing_date}</p>
              </div>
            </div>

            <h3 className="mt-6 font-bold">Document</h3>

            <div className="flex flex-1 flex-row items-start justify-between">
              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblPassport')}</h3>
                  <div className="flex flex-row gap-2">
                    <AiOutlineFileText color="#06C051" fontSize={30}></AiOutlineFileText>
                    <div>
                      <span className="text-base font-bold">123456-900.pdf</span>
                      <p className="text-base font-bold text-[#06C051]">{t('others.othApproved')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblNationalIDPlain') || 'National ID'}</h3>
                  <div className="flex flex-row gap-2">
                    <AiOutlineFileText color="#06C051" fontSize={30}></AiOutlineFileText>
                    <div>
                      <span className="text-base font-bold">123456-900.pdf</span>
                      <p className="text-base font-bold text-[#06C051]">{t('others.othApproved')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblProveAddress')}</h3>
                  <div className="flex flex-row gap-2">
                    <AiOutlineFileText color="#06C051" fontSize={30}></AiOutlineFileText>
                    <div>
                      <span className="text-base font-bold">123456-900.pdf</span>
                      <p className="text-base font-bold text-[#06C051]">{t('others.othApproved')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card.Content>
        </Card.Root>
      ) : undefined}

      {companyInfo?.shareholders.length ? (
        <Card.Root className="mt-4">
          <Card.Header className="font-medium">{t('others.othShareholders')}</Card.Header>
          <Card.Content className="flex-col gap-2">
            <h3 className="font-bold">Personal document</h3>

            <div className="flex flex-1 flex-row items-start gap-6">
              <img src="/svg/director-asset.png" className="aspect-square h-16" alt="" />

              <div className="flex flex-1 flex-row items-start justify-between">
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{companyInfo.shareholders[0].name}</h3>
                  <div>
                    <p className="text-base text-[#727272]">{companyInfo.shareholders[0].telefones[0]?.number}</p>
                    <p className="text-base text-[#727272]">{companyInfo.shareholders[0].email}</p>
                  </div>
                </div>

                <div className="flex-1">
                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">Date of becoming</h3>
                    <span className="text-base text-[#727272]">{companyInfo.shareholders[0].created_at}</span>
                  </div>

                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">Date of Birth</h3>
                    <span className="text-base text-[#727272]">{companyInfo.shareholders[0].date_of_birth}</span>
                  </div>
                </div>

                <div className="flex-1">
                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblGender')}</h3>
                    <span className="text-base text-[#727272]">{companyInfo.shareholders[0].gender}</span>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblNationality')}</h3>
                    <span className="text-base text-[#727272]">{companyInfo.shareholders[0].nationality}</span>
                  </div>
                </div>

                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblAddress1')}</h3>
                  <div className="flex flex-col text-base   text-[#727272]">
                    <span>
                      <b>{t('labels.lblPostalCode')}:</b> {companyInfo.shareholders[0].address[0]?.postal_code}
                    </span>
                    <span>
                      <b>STREET:</b> {companyInfo.shareholders[0].address[0]?.address}
                    </span>
                    <span>
                      <b>{t('labels.lblState')}:</b> {companyInfo.shareholders[0].address[0]?.state}
                    </span>
                    <span>
                      <b>{t('labels.lblCity')}:</b> {companyInfo.shareholders[0].address[0]?.city}
                    </span>
                    <span>
                      <b>{t('labels.lblNeighborhood')}:</b> {companyInfo.shareholders[0].address[0]?.neighborhood}
                    </span>
                    <span>
                      <b>label={t('labels.lblCountry')}:</b> {companyInfo.shareholders[0].address[0]?.country}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="mt-6 font-bold">About Passport</h3>

            <div className="flex flex-1 flex-row items-start justify-between">
              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblPassportNo')}*</h3>
                <p className="text-base text-[#727272]">{companyInfo.shareholders[0].passports[0]?.number}</p>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Expiry Date</h3>
                <p className="text-base text-[#727272]">{companyInfo.shareholders[0].passports[0]?.expiry_date}</p>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Passport Country</h3>
                <p className="text-base text-[#727272]">{companyInfo.shareholders[0].passports[0]?.issuing_country}</p>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Issuance date</h3>
                <p className="text-base text-[#727272]">{companyInfo.shareholders[0].passports[0]?.issuing_date}</p>
              </div>
            </div>

            <h3 className="mt-6 font-bold">{t('labels.lblShareDetails')}</h3>

            <div className="flex flex-1 flex-row items-start justify-between">
              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">Share Issuance Date </h3>
                  <span className="text-base text-[#727272]">{companyInfo.shareholders[0].share_issuance_date}</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblClassOfShares')} *</h3>
                  <span className="text-base text-[#727272]">{companyInfo.shareholders[0].class_of_share}</span>
                </div>
              </div>

              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblSeriesOfShares')}</h3>
                  <span className="text-base text-[#727272]">{companyInfo.shareholders[0].series_of_share}</span>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">Shares Value in ...</h3>
                  <span className="text-base text-[#727272]">{companyInfo.shareholders[0].shares_value}</span>
                </div>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Privileges/Restrictions</h3>
                <p className="text-base text-[#727272]">{companyInfo.shareholders[0].privilegies_or_restrictions}</p>
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-bold text-[#0C1FAA]">Conditions</h3>
                <p className="text-base text-[#727272]">{companyInfo.shareholders[0].conditions}</p>
              </div>
            </div>

            <h3 className="mt-6 font-bold">Document</h3>

            <div className="flex flex-1 flex-row items-start justify-between">
              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblPassport')}</h3>
                  <div className="flex flex-row gap-2">
                    <AiOutlineFileText color="#06C051" fontSize={30}></AiOutlineFileText>
                    <div>
                      <span className="text-base font-bold">123456-900.pdf</span>
                      <p className="text-base font-bold text-[#06C051]">{t('others.othApproved')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblNationalIDPlain') || 'National ID'}</h3>
                  <div className="flex flex-row gap-2">
                    <AiOutlineFileText color="#06C051" fontSize={30}></AiOutlineFileText>
                    <div>
                      <span className="text-base font-bold">123456-900.pdf</span>
                      <p className="text-base font-bold text-[#06C051]">{t('others.othApproved')}</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex-1">
                <div>
                  <h3 className="text-lg font-bold text-[#0C1FAA]">{t('labels.lblProveAddress')}</h3>
                  <div className="flex flex-row gap-2">
                    <AiOutlineFileText color="#06C051" fontSize={30}></AiOutlineFileText>
                    <div>
                      <span className="text-base font-bold">123456-900.pdf</span>
                      <p className="text-base font-bold text-[#06C051]">{t('others.othApproved')}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Card.Content>
        </Card.Root>
      ) : undefined}

      <Card.Root className="mt-4">
        <Card.Header className="font-medium">{t('labels.lblGeneralDocuments')}</Card.Header>
        <Card.Content>
          <div className="flex-1 overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr>
                  <th className="px-4 py-2 text-left font-medium">{t('labels.lblDocumentName')}</th>
                  <th className="px-4 py-2 text-left font-medium">Description</th>
                  <th className="px-4 py-2 text-left font-medium">{t('labels.lblType')}</th>
                  <th className="px-4 py-2 text-left font-medium">Date created</th>
                  <th className="px-4 py-2 text-left font-medium">{t('labels.lblStatus')}</th>
                  <th className="px-4 py-2 text-left font-medium">{t('labels.lblActions')}</th>
                </tr>
              </thead>
              <tbody>
                {companyInfo?.shareholders?.map((shareholder: any, index: any) => (
                  <React.Fragment key={index}>
                    {shareholder.documents.map((document: any, docIndex: any) => (
                      <React.Fragment key={docIndex}>
                        <tr className="border-b-[2px]">
                          {docIndex > 0 && <tr className="border-b-[2px]"></tr>}{' '}
                          <td className="px-4 py-2 text-sm" rowSpan={shareholder.documents.length || 1}>
                            {document.description}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {document.message ? (
                              <span className="font-bold text-[#FF0000]">Not sent</span>
                            ) : (
                              <span className="font-bold text-[#06C051]">Sent</span>
                            )}
                          </td>
                          <td className="px-4 py-2 text-sm">{document.type}</td>
                          <td className="px-4 py-2 text-sm">{formatDate(document.created_at)}</td>
                          {document.aproved === 0 ? (
                            <td className="px-4 py-2 text-sm font-bold text-[#FF0000]">{t('others.othNotApproved')}</td>
                          ) : (
                            <td className="px-4 py-2 text-sm font-bold text-[#06C051]">{t('others.othApproved')}</td>
                          )}
                          <td className="px-4 py-2">
                            <button
                              className="flex items-center justify-center rounded-md border-2 border-[#0C1FAA] px-4 py-1 font-medium text-[#0C1FAA]"
                              onClick={changeOpen}
                            >
                              <FiExternalLink className="mr-2" />
                              {t('others.othViewDocument')}
                            </button>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                    {shareholder.passports.map((document: any, docIndex: any) => (
                      <React.Fragment key={docIndex}>
                        <tr className="border-b-[2px]">
                          {docIndex > 0 && <tr className="border-b-[2px]"></tr>}{' '}
                          <td className="px-4 py-2 text-sm" rowSpan={shareholder.documents.length || 1}>
                            {document.description}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {document.message ? (
                              <span className="font-bold text-[#FF0000]">Not sent</span>
                            ) : (
                              <span className="font-bold text-[#06C051]">Sent</span>
                            )}
                          </td>
                          <td className="px-4 py-2 text-sm">{document.type}</td>
                          <td className="px-4 py-2 text-sm">{formatDate(document.created_at)}</td>
                          {document.aproved === 0 ? (
                            <td className="px-4 py-2 text-sm font-bold text-[#FF0000]">{t('others.othNotApproved')}</td>
                          ) : (
                            <td className="px-4 py-2 text-sm font-bold text-[#06C051]">{t('others.othApproved')}</td>
                          )}
                          <td className="px-4 py-2">
                            <button
                              className="flex items-center justify-center rounded-md border-2 border-[#0C1FAA] px-4 py-1 font-medium text-[#0C1FAA]"
                              onClick={changeOpen}
                            >
                              <FiExternalLink className="mr-2" />
                              {t('others.othViewDocument')}
                            </button>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                    {shareholder.address.map((document: any, docIndex: any) => (
                      <React.Fragment key={docIndex}>
                        <tr className="border-b-[2px]">
                          {docIndex > 0 && <tr className="border-b-[2px]"></tr>}{' '}
                          <td className="px-4 py-2 text-sm" rowSpan={shareholder.documents.length || 1}>
                            {document.description}
                          </td>
                          <td className="px-4 py-2 text-sm">
                            {document.message ? (
                              <span className="font-bold text-[#FF0000]">Not sent</span>
                            ) : (
                              <span className="font-bold text-[#06C051]">Sent</span>
                            )}
                          </td>
                          <td className="px-4 py-2 text-sm">{document.type}</td>
                          <td className="px-4 py-2 text-sm">{formatDate(document.created_at)}</td>
                          {document.aproved === 0 ? (
                            <td className="px-4 py-2 text-sm font-bold text-[#FF0000]">{t('others.othNotApproved')}</td>
                          ) : (
                            <td className="px-4 py-2 text-sm font-bold text-[#06C051]">{t('others.othApproved')}</td>
                          )}
                          <td className="px-4 py-2">
                            <button
                              className="flex items-center justify-center rounded-md border-2 border-[#0C1FAA] px-4 py-1 font-medium text-[#0C1FAA]"
                              onClick={changeOpen}
                            >
                              <FiExternalLink className="mr-2" />
                              {t('others.othViewDocument')}
                            </button>
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </React.Fragment>
                ))}
              </tbody>
            </table>
          </div>
        </Card.Content>
      </Card.Root>
    </>
  );
};

export { CompanyDetailsScreen };
